/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 5d3d2bc2 (Tue Dec 30 16:20:46 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  Address,
  AddressFromJSON,
  AddressToJSON,
  Countries,
  CountriesFromJSON,
  States,
  StatesFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface FetchCountriesRequest extends runtime.BaseRequestParameters {}

export interface FetchInternationalCountriesRequest
  extends runtime.BaseRequestParameters {}

export interface FetchStatesRequest extends runtime.BaseRequestParameters {
  countryCode: string
}

export interface ValidateAddressRequest extends runtime.BaseRequestParameters {
  body: Address
  disableGeocoding?: boolean
  disableAddressVerification?: boolean
}

/**
 * AddressApi - interface
 *
 * @export
 * @interface AddressApiInterface
 */
export interface AddressApiInterface {
  /**
   * List of country codes and the full name of countries.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressApiInterface
   */
  fetchCountriesRaw(
    requestParameters: FetchCountriesRequest
  ): Promise<runtime.ApiResponse<Countries>>

  /**
   * List of country codes and the full name of countries.
   */
  fetchCountries(): Promise<Countries>

  /**
   *
   * @summary Returns code and full name of all available international countries.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressApiInterface
   */
  fetchInternationalCountriesRaw(
    requestParameters: FetchInternationalCountriesRequest
  ): Promise<runtime.ApiResponse<Countries>>

  /**
   * Returns code and full name of all available international countries.
   */
  fetchInternationalCountries(): Promise<Countries>

  /**
   * List of states codes and names for a given country code.
   * @param {string} countryCode An ISO 3166-1 alpha-2 country code like US, CA, or FR.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressApiInterface
   */
  fetchStatesRaw(
    requestParameters: FetchStatesRequest
  ): Promise<runtime.ApiResponse<States>>

  /**
   * List of states codes and names for a given country code.
   */
  fetchStates(requestParameters: FetchStatesRequest): Promise<States>

  /**
   * Use this endpoint to validate an address that will be submitted as part of a resource with an `address` field. To do so, submit the proposed address. The response will comprise valid options for the user to select. If the response is empty, then they must edit their address till there is a result to select.
   * @summary Receive any needed corrections to an address that will be submitted as part of a Community, Program, or User.
   * @param {Address} address
   * @param {boolean} [disableGeocoding] Whether geocoding is required when validating an address. When absent, geocoding is enabled by default.
   * @param {boolean} [disableAddressVerification] Whether address verification with USPS is required when validating an address. When absent, address verification is enabled by default.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressApiInterface
   */
  validateAddressRaw(
    requestParameters: ValidateAddressRequest
  ): Promise<runtime.ApiResponse<Array<Address>>>

  /**
   * Use this endpoint to validate an address that will be submitted as part of a resource with an `address` field. To do so, submit the proposed address. The response will comprise valid options for the user to select. If the response is empty, then they must edit their address till there is a result to select.
   * Receive any needed corrections to an address that will be submitted as part of a Community, Program, or User.
   */
  validateAddress(
    requestParameters: ValidateAddressRequest
  ): Promise<Array<Address>>
}

/**
 *
 */
export class AddressApi extends runtime.BaseAPI implements AddressApiInterface {
  /**
   * List of country codes and the full name of countries.
   */
  async fetchCountriesRaw(
    requestParameters: FetchCountriesRequest
  ): Promise<runtime.ApiResponse<Countries>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/countries`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountriesFromJSON(jsonValue)
    )
  }

  /**
   * List of country codes and the full name of countries.
   */
  async fetchCountries(
    requestParameters?: FetchCountriesRequest
  ): Promise<Countries> {
    const response = await this.fetchCountriesRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Returns code and full name of all available international countries.
   */
  async fetchInternationalCountriesRaw(
    requestParameters: FetchInternationalCountriesRequest
  ): Promise<runtime.ApiResponse<Countries>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/countries/international`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountriesFromJSON(jsonValue)
    )
  }

  /**
   * Returns code and full name of all available international countries.
   */
  async fetchInternationalCountries(
    requestParameters?: FetchInternationalCountriesRequest
  ): Promise<Countries> {
    const response = await this.fetchInternationalCountriesRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * List of states codes and names for a given country code.
   */
  async fetchStatesRaw(
    requestParameters: FetchStatesRequest
  ): Promise<runtime.ApiResponse<States>> {
    if (
      requestParameters.countryCode === null ||
      requestParameters.countryCode === undefined
    ) {
      throw new runtime.RequiredError(
        'countryCode',
        'Required parameter requestParameters.countryCode was null or undefined when calling fetchStates.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/states/{countryCode}`.replace(
        `{${'countryCode'}}`,
        encodeURIComponent(String(requestParameters.countryCode))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StatesFromJSON(jsonValue)
    )
  }

  /**
   * List of states codes and names for a given country code.
   */
  async fetchStates(requestParameters: FetchStatesRequest): Promise<States> {
    const response = await this.fetchStatesRaw(requestParameters)
    return await response.value()
  }

  /**
   * Use this endpoint to validate an address that will be submitted as part of a resource with an `address` field. To do so, submit the proposed address. The response will comprise valid options for the user to select. If the response is empty, then they must edit their address till there is a result to select.
   * Receive any needed corrections to an address that will be submitted as part of a Community, Program, or User.
   */
  async validateAddressRaw(
    requestParameters: ValidateAddressRequest
  ): Promise<runtime.ApiResponse<Array<Address>>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling validateAddress.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.disableGeocoding !== undefined) {
      queryParameters['disableGeocoding'] = requestParameters.disableGeocoding
    }

    if (requestParameters.disableAddressVerification !== undefined) {
      queryParameters['disableAddressVerification'] =
        requestParameters.disableAddressVerification
    }

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/address/validate`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: AddressToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AddressFromJSON)
    )
  }

  /**
   * Use this endpoint to validate an address that will be submitted as part of a resource with an `address` field. To do so, submit the proposed address. The response will comprise valid options for the user to select. If the response is empty, then they must edit their address till there is a result to select.
   * Receive any needed corrections to an address that will be submitted as part of a Community, Program, or User.
   */
  async validateAddress(
    requestParameters: ValidateAddressRequest
  ): Promise<Array<Address>> {
    const response = await this.validateAddressRaw(requestParameters)
    return await response.value()
  }
}
